import { HttpClient } from '@angular/common/http';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { AssetService } from '@rd/core/services/asset-service/asset.service';
import { RdMissingTranslationHandler } from '@rd/errors/missing-translations.handler';
import { HttpLoaderFactory } from '../app/app.module';

export const externalModules = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient, AssetService],
    },
    missingTranslationHandler: {
      provide: MissingTranslationHandler,
      useClass: RdMissingTranslationHandler,
    },
  }),
];

export const externalProviders = [];
